import React, { Component } from 'react';
import { Rect, Line, Image, Text } from 'react-konva';
import {
  lineCap,
  strokeWidth,
  imageBasePath,
  fontFamily,
  dualPedigreeMode,
} from '../../library/constants';
import { isMobilePhone, isMobileIOS, getWidthKonvaText,  } from '../../library/calc';

export const ContinueStr = ({
  branch,
  nodeObjs,
  reloadCanvasTree,
  cursorBecomesPointer,
  cursorBecomesMove,
  userTouchedNode,
  downloadingPedigreeChart,
}) => {

  if( downloadingPedigreeChart )  return null;

  let { left, top, node } = branch;

  const nodeObj = nodeObjs[node];

  if(typeof(nodeObj.p) === 'undefined') return null;
  let pruneCountStr = nodeObj.p;
  // pruneCountStr = '+1';

  if (pruneCountStr.length === 1 && typeof(nodeObj.cyclemaster) !== 'undefined'){
    const cyclemaster = nodeObj.cyclemaster;
    pruneCountStr = nodeObjs[cyclemaster].p;
    if(typeof(pruneCountStr) === 'undefined') return null;

    // console.log(`nodeObj: `, JSON.stringify(nodeObj, null, 2));
    // console.log(`nodeObjs[cyclemaster]: `, JSON.stringify(nodeObjs[cyclemaster], null, 2));
    // console.log(`new pruneCountStr: `, pruneCountStr);
  }

  left = (pruneCountStr.length > 2 ? left +.5: left + 2);
  left = (pruneCountStr.length === 1 ? left + 3: left);
  if(isMobilePhone()) left -= 5;
  // if(isMobileTablet()) top += .5;

  top += .5;
  if (isMobileIOS()){
    top += -.5;
  }

  return <Text
    x={left}
    y={top}
    text={`${pruneCountStr}`}
    fontSize={5}
    fontFamily={fontFamily}
    fontWeight={'bold'}
    fill={'white'}
    onClick={()=>{
      reloadCanvasTree(nodeObj.pr_id);
    }}
    onMouseenter={()=>{
      cursorBecomesPointer();
    }}

    onMouseleave={()=>{
      cursorBecomesMove();
    }}

    onTouchStart={()=>{
      userTouchedNode({
        node,
        callback: ()=>{

          reloadCanvasTree(nodeObj.pr_id);

        },
        fromWhere: 'ContinueStr'
      });
    }}


  />;
};


class Continue extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        image: null
      }

      this.image = new window.Image();
      this.doOnce = false;
    }

    componentDidMount(){

      this.image.src = imageBasePath + 'chevron.svg';
      this.image.onload = () => {
        if(!this.doOnce && this.refs.myRef){
          this.setState({
            image: this.image
          });
          this.doOnce = true;
        }
      }

    }

    render() {

      const {
        nodeObjs,
        reloadCanvasTree,
        cursorBecomesPointer,
        cursorBecomesMove,
        userTouchedNode,
        downloadingPedigreeChart,
      } = this.props;

      if( downloadingPedigreeChart )  return null;

      let {
        left,
        top,
        node,
      } = this.props.branch;

      if(isMobilePhone()) left -= 5;

      if(typeof(nodeObjs[node].p) === 'undefined') return null;

      return (
          <Image
            ref="myRef"
            image={this.state.image}
            scaleX={.1}
            scaleY={.1}
            width={4.8 * 10}
            height={4.8 * 10}
            x={left}
            y={top}

            onClick={()=>{
              reloadCanvasTree(nodeObjs[node].pr_id);
            }}

            onMouseenter={()=>{
              cursorBecomesPointer();
            }}

            onMouseleave={()=>{
              cursorBecomesMove();
            }}

            onTouchStart={()=>{
              userTouchedNode({
                node,
                callback: ()=>{

                 reloadCanvasTree(nodeObjs[node].pr_id);

                },
                fromWhere: 'Continue'
              });
            }}

          />
      );
    }
}


export class ContinueRect extends Component {

  render () {

    const {
        nodeObjs,
        reloadCanvasTree,
        branch,
        cursorBecomesMove,
        cursorBecomesPointer,
        userTouchedNode,
        downloadingPedigreeChart,
    } = this.props;


    if( downloadingPedigreeChart )  return null;

    const node = branch.node;
    if(typeof(nodeObjs[node].p) === 'undefined') return null;

    let { left, top} = branch;

    if(isMobilePhone()) left -= 5;

    const fillColor = '#008A00';

    return (
      <Rect
          x={left}
          y={top}
          width={18.5}
          height={8.5}
          cursor="pointer"
          fill={fillColor}
          strokeWidth={strokeWidth}
          stroke ={fillColor}
          cornerRadius={.75}
          onClick={()=>{
            reloadCanvasTree(nodeObjs[node].pr_id);
          }}

          onMouseenter={()=>{
            cursorBecomesPointer();
          }}

          onMouseleave={()=>{
            cursorBecomesMove();
          }}

          onTouchStart={()=>{
            userTouchedNode({
              node,
              callback: ()=>{

                reloadCanvasTree(nodeObjs[node].pr_id);

              },
              fromWhere: 'ContinueRect'
            });
          }}


        />
    );
  }
}


const addboxLeftShift = -7;

export class TabStr extends Component {

  state = {
   addTabVisible: true
  }

  setTabVisible({addTabVisible}){
    this.setState({
      addTabVisible: addTabVisible
    })
  }

  render () {
    const {
      branch,
      nodeObjs,
    } = this.props;

    if(branch.node < 0 || !this.state.addTabVisible) return null;

    let { left, top } = branch;

    // if(isMobileTablet()) top -= 1;
    top += .3;

    const nearbyTreeMatches = () => {
      return typeof(nodeObjs[branch.node].ntm) !== 'undefined' &&  nodeObjs[branch.node].ntm;
    }
    const fill = ( nearbyTreeMatches() ? "#D8D8D8": "black")

    return (<Text
        x={left}
        y={top}
        text={'+'}
        fontSize={4}
        fontWeight={'bold'}
        fontFamily={fontFamily}
        fill = {fill}
      />);
  }
};



export class LockSvg extends Component {

  constructor(props){
    super(props);
    this.state = {
      image: null,
      addTabVisible: true
    }

    this.image = new window.Image();
    this.doOnce = false;
  }

  componentDidMount(){
    this.image.src = imageBasePath + 'lock.svg';
    this.image.onload = () => {
      if(!this.doOnce && this.refs.lockRef){
        this.setState({
          image: this.image
        });
        this.doOnce = true;
      }
    }

  }

  render () {
    const {
      branch,
    } = this.props;

    if(branch.node < 0 || !this.state.addTabVisible) return null;

    let { left, top } = branch;

    top -= .1;
    left -= .9;
    return (<Image
            ref="lockRef"
            image={this.state.image}
            width={4}
            height={4}
            x={left}
            y={top}

          />);
  }
};



export class ReloadSvg extends Component {

  constructor(props){
    super(props);
    this.state = {
      image: null,
      addTabVisible: true
    }

    this.image = new window.Image();
    this.doOnce = false;
  }

  componentDidMount(){
    this.image.src = imageBasePath + 'reload2.svg';
    this.image.onload = () => {
      if(!this.doOnce && this.refs.reloadRef){
        this.setState({
          image: this.image
        });
        this.doOnce = true;
      }
    }

  }

  render () {
    const {
      branch,
    } = this.props;

    if(branch.node < 0 || !this.state.addTabVisible) return null;

    let { left, top } = branch;

    top += .6;
    left -= .3;
    return (<Image
            ref="reloadRef"
            image={this.state.image}
            width={3}
            height={3}
            x={left}
            y={top}

          />);
  }
};



export class Tab extends Component {

  componentDidUpdate(){

    this.props.pedigreeAddTabObj[this.props.branch.node] = this

  }

  state = {
   addTabVisible: true
  }

  tabRefClickToLaunchNotifyModal({hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, warnPublic}){
    const {
        branch,
        stageLeft,
        stageTop,
        scaleX,
    } = this.props;

    if(branch.node < 0 ) return null;

    let { left, top/*, node*/, addboxTop, addboxLeft} = branch;

    left = ( addboxLeft - stageLeft + addboxLeftShift) * scaleX;
    top = (( addboxTop - stageTop) * scaleX);

    this.props.launchNotifyModalForPedigreeFromTabComponent({ left, top, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, warnPublic});

  }

  triggerClick(){

    const {
        branch,
        stopStageClickPropagation,
        stageLeft,
        stageTop,
        scaleX,
        setPedigreeAddbox,
    } = this.props;

    if(branch.node < 0 ) return null;

    const node = branch.node;

    let { left, top, addboxTop, addboxLeft} = branch;

    if(isMobilePhone() ) return;
    stopStageClickPropagation({fromWhere: 'Tab Pedigree'});

    left = ( addboxLeft - stageLeft + addboxLeftShift) * scaleX;
    top = (( addboxTop - stageTop) * scaleX);
    const visible = true;

    // document.getElementById("debugDiv2").innerHTML += `-- B:: ${left} - ${node}<br/>`;
    setPedigreeAddbox({left, top, visible, node});
  }

  render () {

    const {
        branch,
        cursorBecomesMove,
        cursorBecomesPointer,
        nodeObjs,
    } = this.props;

    if(branch.node < 0 ||
      !this.state.addTabVisible) return null;

    let { left, top} = branch;
    const nearbyTreeMatches = () => {
      return typeof(nodeObjs[branch.node].ntm) !== 'undefined' &&  nodeObjs[branch.node].ntm;
    }
    const fill = ( nearbyTreeMatches() ? "#E5E5E4": "#FFFF00")
    const stroke = ( nearbyTreeMatches() ? "#D8D8D8": "#EFAC31")

    return (
      <Rect
          x={left}
          y={top}
          width={5}
          height={9}
          cursor="pointer"
          fill={fill}
          strokeWidth={strokeWidth}
          stroke = {stroke}
          cornerRadius={.75}

          onMouseenter={()=>{
            cursorBecomesPointer();
          }}

          onMouseleave={()=>{
            cursorBecomesMove();
          }}

        />
    );
  }
}


export class TabTransparentHotSpot extends Component {

  render () {
    const {
        branch,
        userTouchedNode,
        triggerPedigreeCalloutForNode,
        cursorBecomesPointer,
        cursorBecomesMove,
    } = this.props;


    let { left, top, node } = branch;

    if(node < 0) return null;

/*
          strokeWidth={.5}
          stroke = {'black'}
          fill="purple"
 */

    return (
      <Rect
          x={left}
          y={top}
          width={8}
          height={9}

          onTouchStart={()=>{
            userTouchedNode({
              node: this.props.branch.node,
              callback: ()=>{

                triggerPedigreeCalloutForNode({node})

              },
              fromWhere: 'edit pedigreeTab hot'
            });
          }}

          onClick={()=>{

            triggerPedigreeCalloutForNode({node})

          }}

          onMouseenter={()=>{
            cursorBecomesPointer();
          }}

          onMouseleave={()=>{
            cursorBecomesMove();
          }}
        />
    );
  }
}

const Collar = ({ branch, nodeObjs, shouldHideChildrenForDualPedigree}) => {

  const { node, xPoint, isFocusRootCollar/*, onTopNode*/} = branch;
  let { collarStart, collarEnd, testColor} = branch;
  const coord = [xPoint, collarStart, xPoint, collarEnd];
  const hasExs = nodeObjs[node].hasExs;
  // const singleParentNodeId = nodeObjs[node].singleParentNodeId;
  // const heightOfCollar = collarEnd - collarStart;
  // const halfHeight = heightOfCollar / 2;
  // if( typeof(singleParentNodeId) !== 'undefined' ){
  //   console.log(`>: `, JSON.stringify(nodeObjs[singleParentNodeId], null, 2));
  //   if( nodeObjs[node].g === 'm') collarEnd = collarStart + halfHeight;
  //   if( nodeObjs[node].g === 'f') collarStart = collarEnd - halfHeight;
  // }
  let dash = undefined
  if(hasExs && !dualPedigreeMode) dash = [1.5, 2];

  let stroke = ( typeof(testColor) !== 'undefined' ? testColor:  'gray');
  // if(dualPedigreeMode) stroke = (typeof(onTopNode) !== 'undefined' ? 'blue': 'red');


  if( typeof(isFocusRootCollar) !== 'undefined' && shouldHideChildrenForDualPedigree({ branch }) ){

    return null;

  }


  return (
    <Line
      points={coord}
      stroke={stroke}
      strokeWidth={strokeWidth + ( typeof(testColor) !== 'undefined' ? 2: 0)}
      lineCap={lineCap}
      dash={dash}
      perfectDrawEnabled={false}
      listening={false}
    />
  );
};

// const CollarText = ({ branch, nodeObjs}) => {

//   const { idp, node/*, onTopNode*/, collarStart, xPoint/*, collarEnd*/} = branch;

//   return (<Text
//     x={xPoint - 25}
//     y={((typeof(onTopNode) !== 'undefined' ? collarStart: collarStart + 10 ))}
//     text={`collar${( typeof(idp) !== 'undefined' ? '-' + idp: '')}`}
//     fontSize={5}
//     fontFamily={fontFamily}
//     fontWeight={'bold'}
//     fill={(typeof(onTopNode) !== 'undefined' ? 'blue': 'red')}
//     />
//   );
// };


const Twig = ({ branch, nodeObjs}) => {

  const { node, twigStart, twigEnd, sideYPoint, testColor} = branch;
  const hasExs = nodeObjs[node].hasExs;
  const coord = [twigStart, sideYPoint, twigEnd, sideYPoint];
  let dash = undefined
  if(hasExs && !dualPedigreeMode) dash = [1.5, 2];

  let stroke = ( typeof(testColor) !== 'undefined' ? testColor:  'gray');

  return (
    <Line
      points={coord}
      stroke={stroke}
      strokeWidth={strokeWidth + ( typeof(testColor) !== 'undefined' ? 2: 0)}
      lineCap={lineCap}
      dash={dash}
      perfectDrawEnabled={false}
      listening={false}
    />
  );
};

// const TwigText = ({ branch, nodeObjs}) => {

//   const { node, idp, twigStart, sideYPoint} = branch;


//   return (<Text
//     x={twigStart-10}
//     y={sideYPoint + 10}
//     text={`${idp}-twig`}
//     fontSize={5}
//     fontFamily={fontFamily}
//     fontWeight={'bold'}
//     fill={'blue'}
//     />
//   );
// };


const Stem = ({ branch, nodeObjs, dualPedigreeObj}) => {

  let { stemStart, stemEnd, sideYPoint, node} = branch;

  const origTop = nodeObjs[node].origTop;

  if( dualPedigreeObj.whichChildrenNode ===  -1 && typeof(origTop) !== 'undefined' ) sideYPoint = origTop + 35;

  const coord = [stemStart, sideYPoint, stemEnd, sideYPoint];

  return (
    <Line
      points = {coord}
      stroke = {'gray'}
      strokeWidth = {strokeWidth}
      lineCap = {lineCap}
      perfectDrawEnabled={false}
      listening={false}
    />
  );
};


// const StemText = ({ branch, nodeObjs}) => {

//   const { idp/*, node*/, stemStart, sideYPoint} = branch;


//   return (<Text
//     x={stemStart}
//     y={sideYPoint}
//     text={`stem-${( typeof(idp) !== 'undefined' ? '-' + idp: '')}`}
//     fontSize={5}
//     fontFamily={fontFamily}
//     fontWeight={'bold'}
//     fill={'brown'}
//     />
//   );
// };

export class UnionTitle extends Component {

  constructor(props){
    super(props);
    this.state = {
      fontFamily: '',
    }
  }

  touchStart(){
    const {
      branch,
      showDualPedigreeModalChangeName
    } = this.props;

    const { n } = branch;

    showDualPedigreeModalChangeName({node:n, whichField: 'titleName'});

  }

  render () {

    const { branch, fontFamily, showDualPedigreeModalChangeName,  cursorBecomesPointer, cursorBecomesMove }  =  this.props;
    let { titleName }  =  this.props;
    const { left, top} = branch;

    const fontSize = 14;

    titleName = decodeURIComponent(decodeURI(titleName));

    let unionTitleWidth = getWidthKonvaText({
        fontSize,
        fontFamily,
        str: titleName,
        fontStyle: 'bold',
        lineHeight: 2});


    let x = left - (unionTitleWidth / 2);
    return (<Text
      cursor={'pointer'}
      x={x}
      y={top}
      text={titleName}
      fontSize={fontSize}
      fontFamily={fontFamily}
      fontWeight={'bold'}
      fill={'black'}
      onMouseenter={()=>{cursorBecomesPointer()}}
      onMouseleave={()=>{cursorBecomesMove()}}
      onTouchStart={this.touchStart.bind(this)}
      onClick={
        ()=>{
          showDualPedigreeModalChangeName({whichField: 'titleName'});
        }
      }
      />
    );
  }
};



export class BorderSvg extends Component {

  constructor(props){
    super(props);
    this.state = {
      image: null,
      addTabVisible: true,
      filename: ''
    }

    this.image = new window.Image();
  }

  componentDidUpdate(){
    const filename = this.props.titleBorder;
    if( typeof(filename) === 'undefined' ) return;
    this.image.src = imageBasePath  + `dualpedigree/titleBorders/${filename}`
    this.image.onload = () => {

        this.naturalWidth = this.image.naturalWidth;
        this.naturalHeight = this.image.naturalHeight;

      if(this.state.filename !== filename && this.refs.borderRef){
        this.setState({
          image: this.image,
          filename
        });
        this.props.forceUpdateCanvas('BorderSvg');
      }
    }
  }

  render () {
    const {
      branch,
    } = this.props;

    let { left, top, scale } = branch;

    // top -= .1;
    // left -= .9;

    const width = this.naturalWidth * .15;
    if( typeof(this.props.titleBorder) === 'undefined' ) return null;

    if (isNaN(width)) {

      return null;

    }


    return (


          <Image
            ref="borderRef"
            image={this.state.image}
            width={width}
            height={this.naturalHeight * .15}
            scaleY={scale}
            x={left - (width / 2)}
            y={top}

          />);
  }
};


export const assemblePedbranchLines = ({
  branch,
  nodeObjs,
  stopStageClickPropagation,
  cursorBecomesMove,
  cursorBecomesPointer,
  stage,
  setPedigreeAddbox,
  pedigreeAddboxVisible,
  downloadingPedigreeChart,
  reloadCanvasTree,
  userTouchedNode,
  triggerPedigreeCalloutForNode,
  /*panAnimateCenterPedigree,*/
  panAnimateToNode,
  canvasWidth,
  dualPedigreeObj,
  forceUpdateCanvas,
  showDualPedigreeModalChangeName,
  shouldHideChildrenForDualPedigree,
}) => {

  const titleBorder = dualPedigreeObj.titleBorder
  const titleName = dualPedigreeObj.titleName
  const fontFamily = dualPedigreeObj.fontFamily

  let combinedComponentsArray = [];

  const node = branch.node;
  const nodeObj = nodeObjs[node];

  // const isPedigreeGhost = nodeObj.isPedigreeGhost;

  const hasParents = typeof(nodeObj) !== 'undefined' && typeof(nodeObj.hasParents) !== 'undefined' ? nodeObj.hasParents: false;
  // const hasOnlyOneParent = nodeObj.hasOnlyOneParent;



  const stageLeft =  Math.round(stage.current.position().x / stage.current.scaleX()) * -1;
  const stageTop =  (Math.round(stage.current.position().y / stage.current.scaleX()) * -1);
  const scaleX =  stage.current.scaleX();
  const scaleY =  stage.current.scaleY();

  // if(branch.segment === 'collar') combinedComponentsArray.push(<CollarText key={`branch-collar-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY}}/>);
  // if(branch.segment === 'stem') combinedComponentsArray.push(<StemText key={`branch-stem-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY}}/>);
  // if(branch.segment === 'twig') combinedComponentsArray.push(<TwigText key={`branch-twig-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY}}/>);

  if(branch.segment === 'stem') combinedComponentsArray.push(<Stem key={`branch-stem-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY, dualPedigreeObj}}/>);
  if(branch.segment === 'twig') combinedComponentsArray.push(<Twig key={`branch-twig-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY}}/>);
  if(branch.segment === 'collar') combinedComponentsArray.push(<Collar key={`branch-collar-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, shouldHideChildrenForDualPedigree, scaleX, scaleY}}/>);
  if(branch.segment === 'continueStr') combinedComponentsArray.push(<ContinueStr key={`branch-continueStr-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, downloadingPedigreeChart, reloadCanvasTree,  scaleX, scaleY, userTouchedNode}}/>);
  if(branch.segment === 'continue') combinedComponentsArray.push(<Continue key={`branch-continue-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, downloadingPedigreeChart,  reloadCanvasTree,  scaleX, scaleY, userTouchedNode}}/>);
  if(branch.segment === 'continueRect') combinedComponentsArray.push(<ContinueRect key={`branch-continueRect-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, downloadingPedigreeChart, reloadCanvasTree,  scaleX, scaleY, userTouchedNode}}/>);
  if(branch.segment === 'unionTitle') combinedComponentsArray.push(<UnionTitle key={`branch-title-${branch.nodeRight}`} {...{ branch, nodeObjs, titleName, fontFamily, showDualPedigreeModalChangeName, forceUpdateCanvas, cursorBecomesMove, cursorBecomesPointer}}/>);
  if(branch.segment === 'unionBorderSvg') combinedComponentsArray.push(<BorderSvg key={`branch-borderStr-${branch.node}-${branch.top}`} {...{ branch, nodeObjs, titleBorder, forceUpdateCanvas}}/>);

  // const isGhostNode = parseInt(branch.node, 10) < 1;
  // if( dualPedigreeMode && isGhostNode ) combinedComponentsArray.pop();

  // const isDualPedigreeGhost = dualPedigreeMode && typeof(isPedigreeGhost) !== 'undefined';
  // if( isDualPedigreeGhost ) {
  // }

  if( dualPedigreeMode && branch.segment === 'twig'  && parseInt(branch.node, 10) < 1 ) {
    combinedComponentsArray.pop();
  }

  if( dualPedigreeMode && branch.segment === 'stem' && !hasParents && typeof(branch.focusRootSide) === 'undefined' ) {
    combinedComponentsArray.pop();
  }

  if( dualPedigreeMode && branch.segment === 'collar' && parseInt(branch.node, 10) < 1 ) {
    combinedComponentsArray.pop();
  }

  return combinedComponentsArray;
};

export const assemblePedbranchAddTab = ({
  pedigreeAddTabObj,
  branch,
  nodeObjs,
  stopStageClickPropagation,
  launchNotifyModalForPedigreeFromTabComponent,
  cursorBecomesMove,
  cursorBecomesPointer,
  stage,
  setPedigreeAddbox,
  pedigreeAddboxVisible,
  reloadCanvasTree,
  userTouchedNode,
  triggerPedigreeCalloutForNode,
  /*panAnimateCenterPedigree,*/
  panAnimateToNode,
  canvasWidth,
}) => {

  let combinedComponentsArray = [];

  const stageLeft =  Math.round(stage.current.position().x / stage.current.scaleX()) * -1;
  const stageTop =  (Math.round(stage.current.position().y / stage.current.scaleX()) * -1);
  const scaleX =  stage.current.scaleX();
  const scaleY =  stage.current.scaleY();

  if(branch.segment === 'tab' && !isMobilePhone()) combinedComponentsArray.push(<Tab key={`branch-tab-${branch.node}`} /*addTabRef={addTabRef} *//*ref={`node-tab-${branch.node}`}*/ pedigreeAddTabObj={pedigreeAddTabObj}  {...{ branch, nodeObjs, stopStageClickPropagation, launchNotifyModalForPedigreeFromTabComponent, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY, setPedigreeAddbox, userTouchedNode, canvasWidth}}/>);
  if(branch.segment === 'tabTransparentHotSpot' && !isMobilePhone()) combinedComponentsArray.push(<TabTransparentHotSpot key={`branch-tabTransparentHotSpot-${branch.node}`} ref={`node-tabTransparentHotSpot-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY, setPedigreeAddbox, userTouchedNode, triggerPedigreeCalloutForNode, /*panAnimateCenterPedigree,*/ panAnimateToNode, canvasWidth, cursorBecomesMove, cursorBecomesPointer}}/>);
  if(typeof(nodeObjs[branch.node].rl) !== 'undefined' ) {
    if(branch.segment === 'tabStr' && !isMobilePhone()) combinedComponentsArray.push(<LockSvg key={`branch-tabStr-${branch.node}`} ref={`node-tabstr-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY, setPedigreeAddbox, userTouchedNode, triggerPedigreeCalloutForNode, /*panAnimateCenterPedigree,*/ canvasWidth}}/>);
  } else if (typeof(nodeObjs[branch.node].hasMoreAdd) !== 'undefined' ) {
    if(branch.segment === 'tabStr' && !isMobilePhone()) combinedComponentsArray.push(<ReloadSvg key={`branch-tabStr-${branch.node}`} ref={`node-tabstr-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY, setPedigreeAddbox, userTouchedNode, triggerPedigreeCalloutForNode, /*panAnimateCenterPedigree,*/ canvasWidth}}/>);
  } else {
    if(branch.segment === 'tabStr' && !isMobilePhone()) combinedComponentsArray.push(<TabStr key={`branch-tabStr-${branch.node}`} ref={`node-tabstr-${branch.node}`} {...{ branch, nodeObjs, stopStageClickPropagation, cursorBecomesMove, cursorBecomesPointer, stageLeft, stageTop, pedigreeAddboxVisible, scaleX, scaleY, setPedigreeAddbox, userTouchedNode, triggerPedigreeCalloutForNode, /*panAnimateCenterPedigree,*/ canvasWidth}}/>);
  }
  return combinedComponentsArray;
};

// assemblePedbranchLines;
